module.exports = __webpack_public_path__ + "static/img/土壤温度、水份检测可视化软件.54a4fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/土壤温度、水份检测可视化软件.jpg
// module id = ljCM
// module chunks = 15